import React from 'react';

import LiabilitiesWithFinancialInstitution from './LiabilitiesWithFinancialInstitution';

export function LiabilitiesPicker(props) {
  return <LiabilitiesWithFinancialInstitution {...props} />;
}
